// FILEPATH: /C:/Open_market/formulario_contacto_empresas/src/__tests__/bus/index.test.js

import Vue from "vue";
import bus from "@/bus";

describe("bus", () => {
  it("should be an instance of Vue", () => {
    expect(bus).toBeInstanceOf(Vue);
  });

  it("should be able to emit and listen to events", () => {
    const callback = jest.fn();
    bus.$on("test-event", callback);
    bus.$emit("test-event");
    expect(callback).toHaveBeenCalled();
  });
});
